import { Box } from "@mui/material";

export default function Safety({ width = 1920, height = 1080 }) {
   // Base font size at 1920px canvas width
   const baseFontSize = 32; // 2rem equivalent
   
   // Scale fonts with Output resolution to maintain consistent relative size
   const baseWidth = 1920;
   const fontScale = width / baseWidth;
   
   // Calculate border width - scales proportionally with Output resolution
   // At 1920px: 1px, At 3840px: 2px
   const borderWidth = (width / baseWidth) * 1;
   
   return (
      <Box
         sx={{
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
            p: "0.37%", // ~4px at 1080px
            fontWeight: "bold",
            fontSize: `${baseFontSize * fontScale}px`,
            color: "#ccc",
         }}
      >
         16:9
         <Box
            sx={{
               top: 0,
               left: 0,
               width: "100%",
               height: "100%",
               border: `${borderWidth}px solid #f00`,
               position: "absolute",
               zIndex: 1200,
            }}
         />
         <Box
            sx={{
               p: "0.37%", // ~4px at 1080px
               color: "rgba(255,0,0,.4)",
               border: `${borderWidth}px dashed #f00`,
               width: "100%",
               height: "80%",
               position: "absolute",
               top: 0,
               left: 0,
               zIndex: 1000,
            }}
         >
            <Box
               sx={{
                  position: "absolute",
                  bottom: "1.85%", // ~20px at 1080px
                  width: "100%",
                  textAlign: "center",
                  fontSize: `${baseFontSize * fontScale}px`,
               }}
            >
               Caption Safety
            </Box>
         </Box>
         <Box
            sx={{
               p: "0.37%", // ~4px at 1080px
               fontWeight: "bold",
               fontSize: `${baseFontSize * fontScale}px`,
               color: "rgba(255,255,255,.2)",
               border: `${borderWidth}px dashed rgba(255,255,255,.2)`,
               width: "75%", // 1440px / 1920px = 75%
               aspectRatio: "4/3",
               position: "absolute",
               top: "50%",
               left: "50%",
               transform: "translateX(-50%) translateY(-50%)",
            }}
         >
            4:3
         </Box>
      </Box>
   );
}
